import { createControlComponent } from '@react-leaflet/core';
import * as L from 'leaflet';
import type { ControlPosition } from 'leaflet';
import { TranslationService } from '../../../../../services/translation.service';
import CurrentLocationMarker from '../../markers/current-location.marker';
import Colors from '../../../../../helpers/colors.helper';
import { LocateControl } from 'leaflet.locatecontrol';

function CreateLocateControl({ position, onClick }: { position: ControlPosition; onClick?: () => void }) {
  const control = new LocateControl({
    clickBehavior: { inView: 'setView', outOfView: 'setView', inViewNotFollowing: 'setView' },
    drawCircle: false,
    icon: 'leaflet-control-locate-icon',
    iconLoading: 'leaflet-control-locate-icon',
    markerClass: CurrentLocationMarker,
    markerStyle: { color: Colors.vtdBlue600, fillColor: Colors.vtdBlue1000 },
    position,
    setView: 'once',
    showCompass: false,
    showPopup: false,
    strings: { title: TranslationService.get('common.map.usecurrentposition'), popup: TranslationService.get('common.map.currentposition') },
    onLocationOutsideMapBounds: () => {
      alert(TranslationService.get('common.map.locationoutsidemapbounds'));
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    createButtonCallback(container: HTMLElement, options: any) {
      const link = L.DomUtil.create('a', 'leaflet-bar-part leaflet-bar-part-single', container);
      link.title = options.strings.title;
      link.setAttribute('role', 'button');
      link.setAttribute('aria-label', options.strings.title);
      link.setAttribute('href', '#');
      link.addEventListener('click', (e) => {
        e.preventDefault();
        onClick?.();
      });
      const icon = L.DomUtil.create(options.iconElementTag, options.icon, link);
      return { link, icon };
    },
  });

  return control;
}

const CustomLocateControl = createControlComponent(CreateLocateControl);

export default CustomLocateControl;
